import React, { useLayoutEffect, useEffect, useState, useRef,createRef} from "react";
import store from "@/redux/store";
import CommunicationCycleReducer, {getState, getTasks, saveTask, newTaskEvent, setChangedItems, setUpdate} from '@/reducers/CommunicationCycle';

import moment from 'moment';
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import {addCalenderItem, hideModal} from '@/reducers/ModalPopup';


export default function AddEventButtons({...props}) {
    const mref = useRef(null);
   
   
   
   const addCalenderItemEvent=(event, eventTypeId) => {
        store.dispatch( newTaskEvent(eventTypeId) );
        store.dispatch( addCalenderItem({parent:props?.parent, users:store.getState().CommunicationCycleReducer.users,priorities:store.getState().CommunicationCycleReducer.priority,onCloseEvent:closeEventHandler, onSaveEvent: onSaveEventHandler, scheduleTask: onScheduleTaskEvent, checkAvailability: checkAvailability }) );
        }    
        
        const checkAvailability=(event, fromDate, workhours) => {
            
            if (mref.current) {
                mref.current.getAvailability(fromDate, workhours)
            }
            
            }
        
        
    const closeEventHandler=(event) => {
        store.dispatch( hideModal(null) );
        }    
        
        const onSaveEventHandler=(data) => {
            if(props?.parent) {
                data['parent'] = props?.parent["key"]; 
            }
            store.dispatch( saveTask(data) );
//            if(props?.onSubmitHandler) {
//                props?.onSubmitHandler(event);
//            }
            store.dispatch( hideModal(null) );
        }
        
        const onScheduleTaskEvent=(data) => {
            if (mref.current) {
                mref.current.setCurrentValue(data)
            }
        }    
    return (
        <>
                {props?.event_types && Object.keys(props?.event_types).map((eventType, idx) => {
                    let eventTypeId = props?.event_types[eventType]
                  return(
                      
            <button key={eventType}
              type="button"
              onClick={(event) => addCalenderItemEvent(event, eventType)}
              className="ml-2 rounded-md bg-indigo-600 px-1 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              Nieuw {eventType}
            </button>
                  )    
                      
                      
                  })}
                  
                          </>
        
    )
}